import { useEffect, useState } from 'react';

/**
 * WARTOŚĆ Z OPÓŹNIENIEM — do fraz szukania, żeby nie pytać serwera co literę.
 *
 * ⚠️ POLE MA REAGOWAĆ OD RAZU, A ZAPYTANIE NIE. Filtrowanie odbywa się na serwerze, więc bez tego
 * wpisanie nazwiska albo indeksu pliku to kilkanaście osobnych wejść do bazy, z których liczy się
 * ostatnie. Opóźniamy WARTOŚĆ przekazywaną do zapytania, a nie samo pole — inaczej tekst
 * dogania palce z widocznym poślizgiem i wygląda na zacinający się interfejs.
 *
 * ⚠️ MODUŁ WSPÓLNY, bo używa tego szukajka pracowników w raportach i galeria obrazków przy towarze.
 * Druga kopia znaczyłaby dwa różne opóźnienia w dwóch miejscach robiących to samo.
 */
export function useOpoznione<T>(wartosc: T, ms = 250): T {
  const [zwloka, setZwloka] = useState(wartosc);
  useEffect(() => {
    const id = setTimeout(() => setZwloka(wartosc), ms);
    return () => clearTimeout(id);
  }, [wartosc, ms]);
  return zwloka;
}
